import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-tab-about',
  templateUrl: './profile-tab-about.component.html',
  styleUrls: ['./profile-tab-about.component.scss']
})
export class ProfileTabAboutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
